
<template>
  <v-content>
    <v-container fluid>
      <Header :title="title" />
       <v-row class="mt-n3">
        <v-col cols="3">
            <v-autocomplete
              v-model="selectedGroups"
              :items="groupstats"
              item-value="group_id"
              item-text="group_name"
              :label="'Groups' | translate"
              outlined
              autocomplete="off"
              chips
              small-chips
              multiple
              required
              :no-data-text="$t('No data available')"
              @change="changedFilter"
            >
          </v-autocomplete>
        </v-col>
        <v-col cols="2">
          <v-btn class="white--text" small :color="primary_color" @click="resetStats()"  x-large block>
            {{ 'Reset' | translate }}
          </v-btn>
        </v-col>

      </v-row>


      <v-row no-gutters>
        <v-col cols="12">
                <div v-for="(group , index) in filteredgroupstats" :key="index" class="my-12" >
                   <v-card shaped outlined elevation="2" class="mt-4 pa-5">
                    <v-toolbar-title class="grey--text text--darken-4 text-center font-weight-bold">
                      {{group.group_name}}
                      </v-toolbar-title>
                        <div class="d-flex flex-wrap"> 
                    <template>
                      <SimpleCard type="Groups" title="Users" description="Number of users in Group" :color="primary_color" :totalcount="group.total_users" :width=260 />
                      <SimpleCard type="Documents" title="Documents" description="Number of documents managed through Group" color="blue" :totalcount="group.total_personal_docs" :width=260 />
                      <SimpleCard type="Tasks" title="Tasks" description="Number of tasks managed through Group" color="green" :totalcount="group.total_test_case_docs" :width=260 />
                      <SimpleCard type="Equipments" title="Equipment Items" description="Number of equipment managed through Group" color="orange" :totalcount="group.total_equip_docs" :width=260 />
                    </template>
                  </div>
                
                  <div class="row" v-if="group.total_users || group.total_personal_docs">
                    
                          <div class="col-md-4 my-auto">
                            <div class="spinner-border"></div>
                              <AdminCard type="Admins" title="Group Admin" description="Details of Group Admin" color="purple" :totalcount="group.group_admins.length" :width=360 :details="group.group_admins" />
                            
                              <div :class="{ shake: disabled }" v-if="group.inbox_status.breach_docs.length">
                                <div @mouseover="warnDisabled">
                                  <SimpleCard type="Danger" title="Breached Documents" description="Number and details of breached Documents" color="#FD0117" :totalcount="group.inbox_status.breach_docs.length" :width=360 :details="group.inbox_status.breach_docs" />
                                </div>
                              </div>
                         
                          </div>
                          <div class="col">
                              <template>
                                    <v-sheet
                                      color="white"
                                      height="100%"
                                    >
                                      <v-row
                                        class="fill-height"
                                        align="center"
                                        justify="center"
                                      >
                                    <v-card-title> {{"Current Status of Inbox Process Progress" |  translate}}  </v-card-title>
                                        <template >
                                            <DoughnutChart :chart-data="convertDoughnutChart('chartData',group.inbox_status)" :chart-options="convertDoughnutChart('chartOptions',group.inbox_status)"
                                            />
                                        </template>
                                      </v-row>
                                    </v-sheet>
                              </template>
                          </div>
                    
                  </div>
                   </v-card>

                </div>

        </v-col>
      </v-row>
    </v-container>

</v-content>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store"
import {
  FETCH_COMPANY_SETTINGS,
  FETCH_GROUP_STATS,
  RESET_STATE
} from "@/store/actions.type";
// import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
export default {
  name: "Quiz",
  async beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE),
    await store.dispatch(FETCH_COMPANY_SETTINGS, 'profile');
    await store.dispatch(FETCH_GROUP_STATS, '');
    return next();
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch(RESET_STATE)
    next();
  },
  data: function() {
    return {
      title: "Group Statistics",
      search: "",
      primary_color: '',
      isLoading:false,
      storage_url: "",
      selectedGroups:[],
      filteredgroupstats:null,

      //carousel for slides
      slides: [
        'Doughnut',
      ],
      disabled: false,
    };
  },
  components: {
    Header: () => import("@/components/header/Header"),
    DoughnutChart: () => import("@/components/charts/Doughnut"),
    SimpleCard: () => import("@/components/cards/SimpleCard"),
    AdminCard: () => import("@/components/cards/AdminCard"),
  },
  computed: {
    ...mapGetters(['currentUser','loadingdata','companysettings','groupstats']),
   
  },
  created() {
    this.storage_url = process.env.VUE_APP_COMPANYADMIN_STORAGE_URL;
    this.filteredgroupstats = this.groupstats;
    
  },
  async mounted(){
    let company_meta  = JSON.parse(this.currentUser.company.company_meta);
    this.primary_color  = company_meta.primary_color
    if(company_meta.hasOwnProperty('has_quiz')){
      this.has_quiz = (company_meta.has_quiz==='true') //since returned value is a tring and not boolean
    }

    if(this.companysettings.hasOwnProperty('setting_data')){
        this.daily_quiz_question_count = this.companysettings.setting_data.daily_quiz_question_count
        this.daily_quiz_passing_percent = this.companysettings.setting_data.daily_quiz_passing_percent
    }
    this.warnDisabled();


  },
  methods: {
    warnDisabled() {
      this.disabled = true
      setTimeout(() => {
        this.disabled = false
      }, 1500)
    },
    resetStats(){
      this.selectedGroups = [];
      this.filteredgroupstats = this.groupstats;
    },
    convertDoughnutChart(option, data){
      if(option == 'chartData'){

          let datalabels = Object.keys(data);
          let data1= [ this.$t(datalabels[0]), this.$t(datalabels[1])];
          let data2 = [this.$t('Well maintained'),this.$t('Yet to setup')];
          let labels = data1.concat(data2);

          let chartData = {
          labels: labels,
          datasets: [
            {
              backgroundColor: ['#D22B2B', '#FA8072', '#138D75', '#ffd966'],
              data: [data[datalabels[0]], data[datalabels[1]], data.total_outside_filter, data.total_initial_docs],
            }
          ]
        }

        return chartData;
      }else{
        let chartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
              legend: {
                  display: true,
                  position: 'bottom',
                  labels: {
                    // Prevent items with undefined labels from appearing in the legend
                    filter: (item) => item.text !== undefined
                  }
              }
          },
          elements: {
            center: {
              text: 'Red is 2/3 of the total numbers',
              color: '#000000', // Default is #000000
              fontStyle: 'Arial', // Default is Arial
              sidePadding: 20, // Default is 20 (as a percentage)
              minFontSize: 25, // Default is 20 (in px), set to false and text will not wrap.
              lineHeight: 25 // Default is 25 (in px), used for when text wraps
            }
          }
        }
        return chartOptions;
      }
    },
    changedFilter(){
      if(!this.selectedGroups.length){
          this.filteredgroupstats = this.groupstats;
      }
      else{
        this.filteredgroupstats = this.groupstats.filter(v => this.selectedGroups.includes(v.group_id));  
      }
    },
  
  }
};
</script>

<style scoped>
.v-tabs-items {
    background-color: #fafafa;
}

.card-image{
    font-size: 60px;
}

.shake {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}


</style>